import {
  WBBox,
  WBToggleButtonGroup,
  WBRoundedToggleButton,
} from '@admiin-com/ds-web';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import React from 'react';
import { PaymentFrequency, TaskSettlementStatus } from '@admiin-com/ds-graphql';
import { useMediaQuery, useTheme } from '@mui/material';
import { useTaskCreationContext } from '../../../../../features/providers/TaskCreationProvider/useTaskCreationContext';

export const SignPayRoundedOptions = () => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const { taskType } = useTaskCreationContext();

  const isTaxType = React.useMemo(() => taskType === 'tax', [taskType]);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const inputs = React.useMemo(
    () => ({
      paymentFrequency: {
        name: 'futureTaskInput.paymentFrequency',
        defaultValue: PaymentFrequency.ONCE,
      },
      settlementStatus: {
        name: 'futureTaskInput.settlementStatus',
        defaultValue: TaskSettlementStatus.PAYABLE,
        rules: { required: t('taxPayableRequired', { ns: 'taskbox' }) },
      },
    }),
    [t]
  );

  const paymentFrequency = useWatch({
    control,
    name: inputs.paymentFrequency.name,
    defaultValue: inputs.paymentFrequency.defaultValue,
  });

  return (
    <>
      <WBBox mt={2}>
        {!isTaxType && (
          <Controller
            name={inputs.paymentFrequency.name}
            control={control}
            defaultValue={inputs.paymentFrequency.defaultValue}
            render={({ field }) => (
              <WBToggleButtonGroup
                {...field}
                size="medium"
                fullWidth={isMobile ? true : false}
                exclusive
                sx={{ marginTop: 2, gap: 1 }}
                label={t('paymentFrequency', { ns: 'taskbox' })}
              >
                {[PaymentFrequency.ONCE, PaymentFrequency.MONTHLY].map(
                  (key: PaymentFrequency) => {
                    return (
                      <WBRoundedToggleButton
                        value={key}
                        key={key}
                        selected={
                          key === PaymentFrequency.ONCE
                            ? key === paymentFrequency
                            : paymentFrequency !== 'ONCE'
                        }
                      >
                        {t(key === PaymentFrequency.ONCE ? key : 'RECURRING', {
                          ns: 'taskbox',
                        })}
                      </WBRoundedToggleButton>
                    );
                  }
                )}
              </WBToggleButtonGroup>
            )}
          />
        )}
      </WBBox>

      {paymentFrequency !== PaymentFrequency.ONCE && (
        <WBBox mt={2}>
          <Controller
            name={inputs.paymentFrequency.name}
            control={control}
            defaultValue={PaymentFrequency.ONCE}
            render={({ field }) => (
              <WBToggleButtonGroup
                {...field}
                size="medium"
                fullWidth={isMobile ? true : false}
                exclusive
                sx={{
                  marginTop: 2,
                  gap: 1,
                  display: 'flex',
                  padding: 0,
                  flexWrap: 'wrap',
                }}
              >
                {Object.keys(PaymentFrequency)
                  .filter((key) => key !== PaymentFrequency.ONCE)
                  .map((key) => {
                    return (
                      <WBRoundedToggleButton
                        value={key}
                        key={key}
                        size="small"
                        sx={{
                          padding: 1,
                          fontSize: theme.typography.body2.fontSize,
                        }}
                      >
                        {t(key, {
                          ns: 'taskbox',
                        })}
                      </WBRoundedToggleButton>
                    );
                  })}
              </WBToggleButtonGroup>
            )}
          />
        </WBBox>
      )}
    </>
  );
};
